import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TearSheetPNG from "../../icons/tearsheet.png";
import { ReactComponent as ForecastSVG } from "../../svgs/forecast.svg";
import { ReactComponent as PPISVG } from "../../svgs/ppi.svg";
import { ReactComponent as BudgetImpactModelsSVG } from "../../svgs/budget-impact.svg";
import { TEXTS } from "../../constants";
import LinkWrapper from "../Common/LinkWrapper";
import Icon from "../Common/Icon";
import { PERMISSIONS } from "../../constants";
import { interfaces } from "../../typescript";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignContent: "center",
  },
});

type ViewTDProps = {
  rowData: interfaces.context.Data;
};

const ViewTD: FC<ViewTDProps> = ({ rowData }) => {
  const classes = useStyles();
  const { tearSheetURL, financialForecasts, rxStrategy, budgetImpacts, hasPatentAnalysis } = rowData;

  return (
    <span className={classes.container}>
      <LinkWrapper data={hasPatentAnalysis ? tearSheetURL : ""}>
        <Icon path={TearSheetPNG} tooltip={TEXTS.ICONS.lci} placement="bottom" height="22px" width="17px" />
      </LinkWrapper>
      <LinkWrapper data={financialForecasts} popup={TEXTS.ICONS.financialForecasts}>
        <Icon
          icon={<ForecastSVG />}
          tooltip={TEXTS.ICONS.financialForecasts}
          placement="bottom"
          height="16px"
          width="22px"
        />
      </LinkWrapper>
      <LinkWrapper data={rxStrategy} popup={TEXTS.ICONS.ppi} permissions={PERMISSIONS.PPI}>
        <Icon icon={<PPISVG />} tooltip={TEXTS.ICONS.ppi} placement="bottom-end" height="16px" width="22px" />
      </LinkWrapper>
      <LinkWrapper data={budgetImpacts} popup={TEXTS.ICONS.budgetImpacts}>
        <Icon
          icon={<BudgetImpactModelsSVG />}
          tooltip={TEXTS.ICONS.budgetImpacts}
          placement="bottom-end"
          height="19px"
          width="auto"
        />
      </LinkWrapper>
    </span>
  );
};

export default ViewTD;
